import { useEffect, useState } from "react";

import { ISampleType } from "@/models/SampleType";
import { ERROR_500_MESSAGE } from "@/api/constants";
import { SampleTypesApi } from "@/api";
import { useAppSelector } from "@/hooks/redux";

const useSampleTypes = () => {
  const serverConnected = useAppSelector(
    (state) => state.serverReducer.serverConnected
  );
  const [sampleTypes, setSampleTypes] = useState<ISampleType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setError('');
        setLoading(true);
        setSampleTypes(await SampleTypesApi.getSampleTypes());
      } catch (e: any) {
        setError(e.message || ERROR_500_MESSAGE);
      } finally {
        setLoading(false);
      }
    })();
  }, [serverConnected]);

  const addNewSampleType = (sampleType: ISampleType) => {
    setSampleTypes((prevSampleTypes) => [...prevSampleTypes, sampleType]);
  };

  const deleteSampleType = (sampleTypeId: number) => {
    setSampleTypes((prevSampleTypes) =>
      prevSampleTypes.filter(
        (prevType) => prevType.sampleTypeId !== sampleTypeId
      )
    );
  };

  const editSampleType = (sampleTypeId: number, newType: string) => {
    setSampleTypes((prevSampleTypes) =>
      prevSampleTypes.map((prevType) =>
        prevType.sampleTypeId === sampleTypeId
          ? { ...prevType, type: newType }
          : prevType
      )
    );
  };

  return {
    sampleTypes,
    loading,
    error,
    addNewSampleType,
    deleteSampleType,
    editSampleType,
  };
};

export default useSampleTypes;
